import { StyleSheet } from 'react-native';

import {
    heightPercentageToDP,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    description: {
        width: isTabletOrWeb ? widthPercentageToDP(480) : 'auto',
        textAlign: 'center',
        marginTop: heightPercentageToDP(16),
    },
    selfCareButton: {
        minWidth: 120,
        paddingHorizontal: 18,
        width: 'auto',
    },
});

export default styles;
